import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

const TextareaFieldStyled = withStyles((theme) => ({
  root: {
    '& label': {
      '&.MuiFormLabel-root': {
        color: theme.palette.form.labelColor,
        fontSize: theme.typography.pxToRem(14),
        paddingLeft: 16,
      },
      '&.MuiFormLabel-filled': {
        color: theme.palette.form.labelFilledColor,
        paddingLeft: 0,
      },
      '&.Mui-focused': {
        color: theme.palette.primary.main,
        paddingLeft: 0,
      },
      '&.Mui-error': {
        color: theme.palette.error.main,
        paddingLeft: 0,
      },
    },
    '& .MuiInputBase-input': {
      fontSize: theme.typography.pxToRem(14),
      padding: '6px 12px 6px 16px',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottomColor: theme.palette.form.border,
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: theme.palette.form.border,
    },
    '& .MuiFormHelperText-root': {
      fontSize: theme.typography.pxToRem(12),
      marginLeft: 16,
    },
  },
}))(TextField);

export default TextareaFieldStyled;
